{
  "04f6d09aa840de5b": "Delete document",
  "0e47f09a748fa132": "Zoom in",
  "19766ed6ccb2f4a3": "Cancel",
  "1eaa68d4c375ffa4": "An error occurred while preparing the document for printing. Please try again.",
  "1fc9a387654d410f": "Select all",
  "1ff57a29d7c9d11b": "Next",
  "2db046678b9c9d1d": "Dismiss error",
  "331551b0de4157c9": "Pending",
  "34fd124089a65f58": "Next document",
  "3a57bb9fb3bf7756": "Are you sure you want to delete",
  "3d67eca0faf5775e": "Something went wrong while uploading. Please try again.",
  "3d6a45267218977e": "This action cannot be undone.",
  "3f3b4660890bd6d2": "Something went wrong while deleting. Please try again.",
  "424a2551d356754c": "Expired",
  "431c4e7642dbf5b6": "Document deleted successfully",
  "43bef92ae98c1c0e": "Close documents",
  "44837fdf5b780b73": "No required documents",
  "4850b174b713d88c": "Required",
  "4c8261cc8ba3e073": "Uploading for:",
  "507ae671a6e11521": "Upload document",
  "5265434bb9e0e789": "Failed to load documents. Please try again.",
  "59be71333c960fd0": "Optional",
  "5e4fd81d3a118c16": "No optional documents",
  "61e4e1dc2dd666c4": "Use image files only (no .html or .xhtml)",
  "6812a1612e7756b4": "{{selectedCount}} selected",
  "6be36ca49ee85210": "Missing",
  "7009e4afe3c497d5": "Document preview",
  "7b25a882e9bc3515": "Close viewer",
  "84c4c3b5a40e515c": "Choose file for upload",
  "865e89de78d94c74": "Upload",
  "942087cc2d41e013": "Retry",
  "a57b08a480b822a0": "Previous",
  "a64c8281778a453a": "Previous document",
  "b09c73d9d3f80210": "Choose file",
  "b4e929d8bcfe0418": "Documents",
  "bc7b631a689b45ca": "Zoom out",
  "cacfb7d8705ac666": "Back to documents list",
  "cbeec9440db96406": "There is already a download in progress. Please wait for it to complete.",
  "cea4d2e010b8fd52": "Clear selection",
  "d6eafe8235910042": "Download",
  "df0fe79898ef413e": "Print",
  "e2d0a54968ead24e": "Delete",
  "e660e4b07c7b75c9": "An error occurred while preparing the document for download. Please try again.",
  "ea2b3062479788f4": "Rotate counter-clockwise",
  "fb594c58c73d2bf8": "Rotate clockwise"
}
